<template>
  <HeaderMobile
    v-if="
      (mobileVersion && startPage) ||
      (quiz.mobileVersionQuiz?.onlyFormBool &&
        mobileVersion &&
        !visibleContactPopup)
    "
  />
  <section
    :data-n="n"
    :class="[
      style.sectionRightPart,
      photoSection?.type === 'horisontal' ? style.sectionHorisontal : ''
    ]"
    :style="getStylerRightSection(photoSection, Number(n))"
    v-for="(photoSection, n) in rightSectionList"
    v-if="startPage || !mobileVersion"
    :key="mobileVersion + '_' + n"
    ref="sectionRightPart"
  >
    <section
      :class="style.contentSection"
      v-if="photoSection?.type === 'vertical' || !photoSection?.type"
    >
      <div :class="style.numeric" v-if="isRenderNumericRightPart">
        {{ Number(n) + 1 }}
      </div>
      <div :class="style.imgs" :style="{height: heightImgs[Number(n)]}">
        <section
          :class="getClassImg(photoSection.countImg)"
          v-for="n in getCountImg(photoSection.countImg)"
          :key="n"
        >
          <div
            :class="style.photoRight"
            id="pictureHere"
            :data-img="photoSection.img[n - 1]"
            :state-queue="n"
          >
            <video
              v-if="videoReady && isVideoPath(photoSection.img[n - 1])"
              autoplay
              muted
              loop
              playsinline
              webkit-playsinline
              preload="auto"
              :style="{width: '100%', height: '100%', objectFit: 'cover'}"
              :key="'video-' + photoSection.img[n - 1]"
            >
              <source
                :src="getVideo(photoSection.img[n - 1])"
                :type="getTypeVideo(photoSection.img[n - 1])"
              />
            </video>
          </div>
        </section>
      </div>
      <div
        v-if="photoSection.title || photoSection.subTitle"
        :class="style.text"
      >
        <h4 v-if="photoSection.title" v-text="photoSection.title" />
        <p v-if="photoSection.subTitle" v-text="photoSection.subTitle" />
      </div>
    </section>
    <section
      :class="[style.contentSection, style.contentSectionHorisontalBlock]"
      v-if="photoSection?.type === 'horisontal'"
      :style="{
        paddingTop: isPreviousRightBlockHorisontal(n)
          ? mobileVersion
            ? '40px!important'
            : '30px!important'
          : '',
        borderBottom: isHideBorderRightBlock(n) ? 'none' : ''
      }"
    >
      <div :class="style.numeric" v-if="isRenderNumericRightPart">
        {{ Number(n) + 1 }}
      </div>
      <div :class="style.imgs">
        <section
          :class="getClassImg(photoSection.countImg)"
          v-for="n in getCountImg(photoSection.countImg)"
          :key="n"
        >
          <div
            :class="style.photoRight"
            id="pictureHere"
            :data-img="photoSection.img[n - 1]"
            :state-queue="n"
          >
            <video
              v-if="videoReady && isVideoPath(photoSection.img[n - 1])"
              autoplay
              muted
              loop
              playsinline
              webkit-playsinline
              preload="auto"
              :style="{width: '100%', height: '100%', objectFit: 'cover'}"
              :key="'video-' + photoSection.img[n - 1]"
            >
              <source
                :src="getVideo(photoSection.img[n - 1])"
                :type="getTypeVideo(photoSection.img[n - 1])"
              />
            </video>
          </div>
        </section>
      </div>
      <div
        v-if="photoSection.title || photoSection.subTitle"
        :class="style.text"
      >
        <h4 v-if="photoSection.title" v-text="photoSection.title" />
        <p v-if="photoSection.subTitle" v-text="photoSection.subTitle" />
      </div>
    </section>
  </section>
  <section
    :class="style.fakeLeftPart"
    :style="{
      height: (leftPartHeight as number) - 100 + 'px',
      opacity: getCountRightSection === 1 ? 0 : 1
    }"
    v-if="mobileVersion && startPage"
  ></section>
</template>

<script lang="ts">
import style from "./RightPart.module.scss";
import styleLeft from "../LeftPart/LeftPart.module.scss";
import HeaderMobile from "../components/HeaderMobile/HeaderMobile.vue";
import {modifyQuiz} from "@/page/quiz/scriptQuiz";
import {DOMAIN} from "@/http";
import {defineComponent} from "vue";
import {section} from "@/page/quiz/typeQuiz";

export default defineComponent({
  name: "RightQuizPart",
  components: {HeaderMobile},
  props: {
    leftPartHeight: Number,
    leftPartRef: Object
  },
  emits: ["leftPartHeightChange", "sendSectionRightPart"],
  data() {
    return {
      style,
      styleLeft,
      DOMAIN,
      heightImgs: [] as string[],
      srcUploaded: [] as string[],
      videoReady: false,
      modifyQuiz
    };
  },
  mounted() {
    this.initialization();
  },
  methods: {
    isHideBorderRightBlock(n: number) {
      if (n === this.rightSectionList.length - 1) {
        return true;
      }
      return (
        !this.rightSectionList[n + 1]?.type ||
        this.rightSectionList[n + 1]?.type === "vertical"
      );
    },
    isPreviousRightBlockHorisontal(n: number) {
      if (n === 0) {
        return false;
      }
      return (
        !this.rightSectionList[n - 1]?.type ||
        this.rightSectionList[n - 1]?.type === "vertical"
      );
    },
    initialization() {
      setTimeout(() => {
        this.srcUploaded = [];
        this.prepairPrintPhoto();
        for (let index = 0; index < this.rightSectionList.length; index++) {
          this.getHeightImgs(index);
        }
        this.sendSectionRightPart();
      }, 500);
    },
    sendSectionRightPart() {
      this.$emit("sendSectionRightPart", this.$refs.sectionRightPart);
    },
    getCountImg(num: number) {
      if (this.mobileVersion) {
        return num > 1 ? 2 : 1;
      }
      if (!num) {
        return 1;
      }
      if (num == 3) {
        return 4;
      }
      return Number(num);
    },
    getClassImg(num: number) {
      if (this.mobileVersion) {
        num = num > 1 ? 2 : 1;
      }
      let classCount = "";
      if (num == 2) {
        classCount = "two";
      } else if (num == 3) {
        classCount = "four";
      } else {
        classCount = "one";
      }
      return this.style[classCount];
    },
    getStylerRightSection(rightSection: section, n: number) {
      interface IStyle {
        [key: string]: string | undefined;
        marginBottom?: string;
        paddingBottom?: string;
        backgroundColor?: string;
        height?: string;
      }
      let style: IStyle = {};
      let heightRightPart = window.innerHeight;
      if (this.mobileVersion) {
        if (
          n != this.getCountRightSection - 1 ||
          this.getCountRightSection == 1
        ) {
          style["marginBottom"] = "4px";
        } else {
          style["paddingBottom"] = "4px";
          if (!rightSection?.type || rightSection?.type === "vertical")
            style["backgroundColor"] = "black";
        }
        let leftPart = this.leftPartRef as HTMLDivElement;

        if (this.startPage) {
          this.leftPartHeightChange(leftPart?.offsetHeight || 200);
        }
      }

      if (rightSection?.type === "vertical" || !rightSection?.type) {
        let rightSectionHeight = rightSection?.height
          ? rightSection.height
          : 100;
        let heightRightSection =
          (heightRightPart / 100) * rightSectionHeight + "px";
        style["height"] = heightRightSection;
      }
      return style;
    },
    getHeightImgs(n: number) {
      if (this.mobileVersion) {
        this.heightImgs[n] = "100%";
        return;
      }
      let height = "calc(100%";
      let contentSection = document.querySelectorAll(
        "." + this.style.contentSection
      )[n];
      let currentElement = this.modifyQuiz("get", "", ["rightSectionList"])[n];
      let text = contentSection?.querySelector(
        "." + this.style.text
      ) as HTMLDivElement;
      let clientHeightText = text?.clientHeight ? text.clientHeight : 0;
      if (currentElement.title || currentElement.subTitle) {
        height += " - " + clientHeightText + "px";
      }
      this.heightImgs[n] = height + ")";
    },

    leftPartHeightChange(value: number) {
      setTimeout(() => {
        this.$emit("leftPartHeightChange", value);
      }, 100);
    },
    prepairPrintPhoto() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.leftPartHeightChange((this.leftPartHeight as number) + 100);
          const leftPart = document.querySelector(
            "." + this.styleLeft.leftPart
          ) as HTMLDivElement;
          setTimeout(() => {
            if (this.mobileVersion) {
              leftPart.style.bottom = "-100px";
            } else {
              leftPart.style.bottom = "";
            }
          }, 100);
        });
        this.videoReady = true;
        // this.leftPartHeightChange((this.leftPartHeight as number) + 100);
      });
    },
    notOpenVideo(video: HTMLVideoElement) {
      video.addEventListener("webkitfullscreenchange", () => {
        if (document.fullscreenElement !== null) {
          document.exitFullscreen();
        }
      });

      video.addEventListener("webkitbeginfullscreen", (event) => {
        event.preventDefault();
        return false;
      });

      video.addEventListener("webkitendfullscreen", (event) => {
        event.preventDefault();
        return false;
      });
    },
    getTypeVideo(video: string) {
      if (video.toLowerCase().includes("mp4")) {
        return "video/mp4";
      }
      return "video/webm";
    },
    getVideoPath(photoSection: section, n: number) {
      return photoSection.img[n - 1]
        ?.replace(/\.mp4$/i, "")
        .replace(/\.webm$/i, "");
    },
    isVideoPath(path = "") {
      return /\.(mp4|webm|ogg)(?:$|[?#])/i.test(path);
    },
    getVideo(video: string) {
      return `https://${DOMAIN}/api/img?name=${encodeURIComponent(video)}`;
    }
  },
  computed: {
    quiz() {
      return this.$quizStore.getQuiz;
    },
    mobileVersion() {
      return this.$quizStore.getMobileVersion;
    },
    rightSectionList() {
      const rightSectionList = this.modifyQuiz("get", "", ["rightSectionList"]);
      if (Array.isArray(rightSectionList)) {
        return rightSectionList;
      }
      return Object.values(rightSectionList);
    },
    onlyFormBool() {
      return modifyQuiz("get", "", ["onlyFormBool"]);
    },
    visibleContactPopup(): number {
      setTimeout(() => {
        let leftPart = document.querySelector("#leftPart") as HTMLElement;
        const transformValue = leftPart.style.transform;
        let transformValueMatch = transformValue.match(
          /translate\([^,]+,\s*([^)]+)/
        );
        if (!transformValueMatch) {
          return 0;
        }
        return (
          parseInt(
            transformValueMatch[1].replace("calc(", "").replace("px", "")
          ) > 0
        );
      }, 300);
      return 0;
    },
    startPage() {
      return this.$quizStore.getStartPage;
    },
    getCountRightSection() {
      return this.modifyQuiz("get", "", ["rightSectionList"])?.length;
    },
    isRenderNumericRightPart() {
      if (this.mobileVersion && this.quiz?.isNumericRightSection?.mobile) {
        return true;
      } else if (!this.mobileVersion && this.quiz?.isNumericRightSection?.pc) {
        return true;
      }

      return false;
    }
  },
  watch: {
    mobileVersion() {
      this.initialization();
    }
  }
});
</script>
